import React from "react";
import {PageWrapper} from "../../Components/PageWrapper/PageWrapper";
import ServicePageTemplate from "../../Containers/ServiceContainers/ServicePageTemplate";
import {SiteData} from "../../Constants/siteData";
import PageHeader from "../../Components/common/PageHeader";
import {SEO} from "../../Components/SEO/SEO";

export default function StumpGrinding() {
    return (
        <PageWrapper>
            <SEO title={SiteData.stumpGrinding.metaData.title} description={SiteData.stumpGrinding.metaData.description}/>
            <PageHeader header={SiteData.stumpGrinding.h1} subtitle={SiteData.stumpGrinding.subtitle}/>
            <ServicePageTemplate body={SiteData.stumpGrinding.body}/>
        </PageWrapper>
    )
}
